import React from 'react';
import './Banner5.css';
import Banner5 from '../../Assets/banner5.png'; // Desktop image path
import Banner5Mob from '../../Assets/banner5-mob.png'; // Mobile image path

const Banner = () => {
  return (
    <div id="b5" className="banner5-div">
      <div className="banner5-header"> 
        Specifications
      </div>
      <div className="banner5-box"> 
      </div>
      <div className="banner5-body"> 
        <img className="banner5 desktop" src={Banner5} alt="Banner5" />
        <img className="banner5 mobile" src={Banner5Mob} alt="Banner5 Mobile" />
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner5/Banner5.js